// Modules
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from "hooks/system/useLanguage"

// Styles
import './View.scss'

// Component: Layout > Page > View
function View ({ children, className, name, style }) {
	// Data
	// const { translate } = useLanguage('components.layout.page.components.view')

	// Effects
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [name])

	// Render
	return (
		<div
			data-view={name}
			data-component="view"
			className={
				'aix-view' +
				(className ? ` ${className}` : '')
			}
			style={style}>
			{children}
		</div>
	)
}

// Properties
View.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	style: PropTypes.object
}

// Export
export default View
